<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title>
        <v-toolbar-title>TỔNG KẾT LẠI CHO ĐỐI TƯỢNG CỤ THỂ</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="closeDialog">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          disable-sort
          :headers="headers"
          :items="data"
          mobile-breakpoint="0"
          :items-per-page="5"
          :footer-props="{
            'items-per-page-text': 'Hiển thị mỗi trang',
            'items-per-page-all-text': 'Tất cả'
          }"
        >
          <template v-slot:[`item.index`]="{ item }">
            {{ item.index }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn width="97px" outlined class="ma-2" @click="closeDialog">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="onSave">TỔNG KẾT LẠI</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      dialog: false,
      data: [],
      headers: [
        { text: 'STT', value: 'index' },
        { text: 'Họ tên', value: 'name' },
        { text: 'Mã học sinh', value: 'code' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      user: 'auth/user'
    })
  },
  methods: {
    ...mapActions('tuitionFeePeriod', ['reSummary']),
    openDialog(data = []) {
      this.data = data
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.resetData()
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    onSave() {
      this.$dialog.confirm({
        title: 'Xác nhận tổng kết lại?',
        text:
          'Thao tác này có thể mất một chút thời gian. Thông tin cũ có thể bị thay đổi và không thể hoàn tác. Bạn muốn tiếp tục tổng kết lại?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.reSummary({
              status: 'running',
              type: 'specific',
              id: this.detailPeriod.id,
              generatedBy: this.user.id,
              data: this.data.map(x => x.code)
            })
            this.$emit('onSave')
            this.closeDialog()
          } catch (e) {
            this.$alert.error(e)
          }
        }
      })
    }
  }
}
</script>
